import store from './../store/index';

export default {
	mine: '个人中心',
	home: '医院简介',
	server: '首页',
	guide: '就医指导',
	selectlogin: '登录绑定',
	createCard: '新建就诊卡',
	createChildCard: '新建儿童就诊卡',
	bindCard: '成人绑卡',
	bindChildCard: '儿童绑卡',
	bindSuccess: '绑卡成功',
	createSuccess: '建卡成功',
	infoSupplementary:'患者信息补录',
	introduction: '医院简介',
	trendsDetail: '文章详情',
	minePaint: "我的就诊卡",
	minePaintDetail: '详细信息',
	register: '选择科室',
	docList: '医生信息',
	selectDoctor: '选择医生',
	// 问卷调查 start
	question: "问卷调查",
	selectQuestionType: "选择问卷类型",
	physicalExamination:'体检缴费',
	physicalDetails:'体检缴费详情',
	questionnaire: "就诊满意度调查",
	// 问卷调查 end
	detailList: '挂号列表',
	details: '挂号详情',
	socPay: '医保统筹支付',
	success: '挂号成功',
	payList: '缴费列表',
	payDetails: '缴费详情',
	paySuccess: '缴费成功',
	registerList: '挂号记录',
	registerDetail: '挂号记录详情',
	familyDoctor: '家庭医生',
	familyDoctorPerson: '个人基本信息表',
	familyDoctorHealth: '个人基本信息表',
	familyDoctorLive: '个人基本信息表',
	contracted: '家庭医生（团队）签约服务协议书',
	confirmMsg: '预约及确认信息',
	signingRecord: '签约医生记录',
	ordinaryPeople: '一般人服务包',
	children: '儿童服务包',
	pregnantWoman: '孕妇服务包',
	diabetes: '糖尿病服务包',
	hypertension: '高血压服务包',
	aged: '老年人服务包',
	elcsign: '电子签名录入',
	explain: '协议详情',
	reportList: '报告列表',
	paidDetail: '已缴费详情',
	cheackUpDetail: '检查报告详情',
	cheackOutDetail: '检验报告详情',
	heathlyCodeIndex: '电子登录码',
	heathlyCodeSignQr: '电子健康码申领',
	expertSelectDept: '医生介绍-选择科室',
	expertSelectDoctor: '医生介绍-选择医生',
	expertSelectDoctor2: '专家介绍-选择医生',
	expertSelectDoctor3: '专家介绍-选择医生',
	expertDetail: '专家详情',
	expertDetail2: '专家详情',
	hospitalNews: '医院动态',
	selectTime: '选择时间段',
	invoice: "发票查询",
	invoiceQRcode: "扫码查看发票",
	dailyList: "每日清单",
	depositDetail: "押金补缴详情",
	depositPay: "押金补缴",
	depositRecord: '押金补缴记录',
	zhuyuanRegistration: '入院登记',
	collectionInfo: '住院登记补录信息',
	zhuyuanSettleList: '医疗费用清单',
	zhuyuanListDetail:'医疗费用清单明细',
	zhuyuanListSearch:'医疗费用清单明细',
	socialSettleList: '医保结算清单',
	socListDetail: '医保结算清单详情',
	outHospitalSettlement: '出院结算',
	deptList:'科室简介',
	exaPaySuccess:'体检缴费成功',
	recordDetails:'体检已缴费详情',
	physicalExaminationReport:'体检报告',
	paymentFailList:'微信医保缴费记录',
	onlineInsurancePay:'确认支付',
	onlineInsuranceStatus:'医保支付状态确认',
	authFail:'医保授权失败',
	authorization:'授权同意书'
};
